/**
 * Hands the browser a generated file. Kept out of the component so the
 * object-URL lifecycle lives in one place: the URL is revoked immediately
 * after the click, since the download is already queued by then.
 */
export function downloadTextFile(
  fileName: string,
  contentType: string,
  content: string,
): void {
  const url = URL.createObjectURL(new Blob([content], { type: contentType }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
